module.exports = __webpack_public_path__ + "img/sure-hero-mobile.a1a9a18d.svg";